type CardProps = {
  title: string;
  value?: string;
  loading?: boolean 
  valueInfo?: string;
  delayed?: boolean;
};

export const Card = ({
  title, 
  value, 
  valueInfo,
  delayed
}: CardProps) => {
  return (
      <div
        className={`bg-white border border-gray5 shadow-md rounded-2xl p-5 transition hover:shadow-lg hover:scale-[1.01] ${delayed ?  "animate-pulse font-semibold animate-pulse-color" : ""} h-[150px]` }
      ><div className="flex flex-col items-center justify-center">
          <h3 className="text-xl font-bold mb-2">{title}</h3>

          <div className="flex flex-col items-center">
            <span className="text-3xl font-bold">
              {(value ?? 0)}
            </span>
            <span className="text-xl font-bold">
            </span>
          </div>
        </div>
        {valueInfo && <div className="flex flex-col justify-between items-end">
          <span className="bg-white text-black text-xs font-bold px-2 py-0.5 rounded-full shadow animate-ping-fast">{valueInfo}</span>
        </div>}
      </div>
  );
};
